<div edlFocusTrap class="focus-trap-container">
<div class="modal-header">
    <h4 class="modal-title">Action Required</h4>
    <button type="button" class="btn btn-x btn-link cancel" (click)="activeModal.dismiss('cancel')" aria-label="Close"><i class="fas fa-times" aria-hidden="true"></i></button>
</div>
<div class="modal-body mb-3 ">
    <div>You have expired cycles that need addressed. Please click on the following links to complete the expired cycles.</div>
    <hr>
    <div class="m-2 expiredCyclesList">
        <div  *ngFor="let cycle of Cycles | propertyFilter:{ UserStatus: 4 }"  class="cycle-history-item" > 
            <div class="m-3">
                    <a  [uiSref]="route" [uiParams]="{ cycleId: cycle?.CycleID, actionRequired: false }" [uiOptions]="{ reload: true }">
                            <status-indicator class="header me-1" [statusId]="cycle.UserStatus"></status-indicator>   
                            {{ cycle.StartDate | date: 'MMMM dd, yyyy' }} - {{ cycle.EndDate | date: 'MMMM dd, yyyy' }} </a> <small>Expired  {{ GetExpirationDays(cycle.EndDate | amDifference: today : 'days' : false) }} days ago.</small>
            </div>
        </div>
    </div>

</div>
</div>